module.exports = __webpack_public_path__ + "pcau/img/news-top.0d1b58fb.jpg";